import { render, staticRenderFns } from "./questionType.vue?vue&type=template&id=2b24d551&scoped=true&"
import script from "./questionType.vue?vue&type=script&lang=js&"
export * from "./questionType.vue?vue&type=script&lang=js&"
import style0 from "./questionType.vue?vue&type=style&index=0&id=2b24d551&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24d551",
  null
  
)

export default component.exports